import { deleteIcon, videoIcon } from "../../../../Shared/SVGs/Shared";
import { calculateRemainingTime } from "../../../../utilities";
const getFormattedDateRange = (date) => {
  const isValidDate = (date) => !isNaN(new Date(date).getTime());
  const currentDate = isValidDate(date) ? new Date(date) : new Date();
  return currentDate.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "2-digit",
  });
};

export const ActiveCampgainFooter = ({ campaign, videoCount }) => {
  return (
    <>
      <div className="footer-active">
        <div className="d-flex align-items-center">
          {videoIcon}{" "}
          <span style={{ color: "black", marginLeft: "7px" }}>
            {videoCount}
          </span>
        </div>

        <div className="date-info">
          <div className="duration">
            {getFormattedDateRange(campaign?.start_date)} -{" "}
            {campaign?.ongoing
              ? "Ongoing"
              : getFormattedDateRange(campaign?.end_date)}
          </div>
        </div>

        <div>{/* {deleteIcon} */}</div>
      </div>
      <div className="expiry-info">
        {calculateRemainingTime(campaign?.end_date)}
      </div>
    </>
  );
};

export const PastCampgainFooter = ({ campaign, videoCount }) => {
  return (
    <div className="footer-past">
      <div className="d-flex align-items-center">
        {videoIcon}{" "}
        <span style={{ color: "black", marginLeft: "7px" }}>{videoCount}</span>
      </div>

      <div className="date-info">
        <div className="duration">
          {getFormattedDateRange(campaign?.start_date)} -{" "}
          {getFormattedDateRange(campaign?.end_date)}
        </div>
      </div>

      <div>{/* {deleteIcon} */}</div>
    </div>
  );
};

export const DraftCampgainFooter = () => {
  return (
    <div className="footer-draft">
      <div>{/* {deleteIcon} */}</div>
    </div>
  );
};
